<app-floating-info></app-floating-info>
<router-outlet></router-outlet>
<button
  *ngIf="isLoggedIn"
  mat-icon-button
  class="error-fab"
  aria-label="Report Error"
  (click)="openErrorReportDialog()"
  matTooltip="{{ labels.TITLE }}"
>
  <mat-icon fontSet="fa" fontIcon="fa-bug"></mat-icon>
</button>
